import { DataDisplayEvent } from "@mcleod/components";
import { LayoutUrl } from "@mcleod/core";
import { AutogenLayoutOriginDestinationRateQuickInfo } from "./autogen/AutogenLayoutOriginDestinationRateQuickInfo";

export class OriginDestinationRateQuickInfo extends AutogenLayoutOriginDestinationRateQuickInfo {

    textboxDescriptionOnDataDisplay(event: DataDisplayEvent) {
        this.textboxDescription.printableLabel.link = LayoutUrl.create(
            "lme/dispatch/rates/AutoRate",
            {
                mode: "update",
                key: event.rowData?.get("rate_id"),
                odRateId: event.rowData?.get("id")
            }
        );
    }
}
